import CustomElement from '../core/custom.js';

// <collapse-object class="CollapseObject">
// 	<button aria-controls="collapseID" aria-expanded="false" id="collapseID-btn" type="button" class="js-collapse-btn">button</button>
// 	<div id="collapseID" role="region" aria-labelledby="collapseID-btn" hidden="true" class="js-collapse CollapseObject__content">
// 		<div class="CollapseObject__content__inner">
// 			content
// 		</div>
// 	</div>
// </collapse-object>

export default window.customElements.define('collapse-object', class extends CustomElement {
    constructor() {
        super();

        this.events = {
            'click .js-collapse-btn': 'onCollapse'
        }
    }

    connectedCallback() {
        this.$btn = this.querySelector('.js-collapse-btn')
        this.$content = this.querySelector('.js-collapse')
        
		if (!this.$content) {
            return console.warn('CollapseObject: This component must be have a .js-collapse child', this)
        }
        
        this.$contentInner = this.$content.firstElementChild
        
        this._expanded = this.getAttribute('data-expanded') ?? false
        
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    onCollapse() {
        if (!this.matchesBreakpoint) return
        
        if (!this._expanded) {
            this._open()
        } else {
            this._close()
        }
    }

    onBreakpoint({matches}) {
        if (!matches) {
            this.$content.removeAttribute('hidden');
            this.$content.style.height = ''
        } else {
            if (!this._expanded) {
                this._close(0)
            } else {
                this._open(0)
            }
        }
    }

    async _wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    async _open(duration = 800) {
        clearTimeout(this.timer)
        this.$content.removeAttribute('hidden')
  
        await this._wait(0);
  
        this.$content.style.height = `${this.$contentInner.scrollHeight}px`
        
        this._expanded = true
        this.$btn.setAttribute('aria-expanded', true)
        this.classList.add('is-active');
  
        this.timer = setTimeout(() => {
            this.$content.style.height = null
        }, duration)
    }

    async _close(duration = 800) {
        clearTimeout(this.timer);

        this.$content.style.height = `${this.$contentInner.scrollHeight}px`

        await this._wait(0);

        this.$content.style.height = '0px';
        
        this._expanded = false
        this.$btn.setAttribute('aria-expanded', false)
        this.classList.remove('is-active');

        this.timer = setTimeout(() => {
            this.$content.setAttribute('hidden', true)
        }, duration)
    }
});
